import { useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';

const InstitutionSignUpForm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/register/institution/basic');
  }, []);

  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Sign Up</h3>
        <p className="text-body-tertiary">Register your institution today</p>
      </div>
      <Outlet />
      <div className="text-center">
        <Link to="/sign-in" className="fs-9 fw-bold">
          Sign in to an existing account
        </Link>
      </div>
    </>
  );
};

export default InstitutionSignUpForm;
